import React, { ReactNode } from 'react'

import 'config/inter-webview-bridge'

import { GlobalStyledContainer } from 'common'
import { QueryClientContextProvider } from 'contexts/query-client-context-provider/QueryClientContextProvider'
import { AppContextProvider } from 'contexts/app-context/components'

type AppProps = Readonly<{
  children: ReactNode
}>

export default function App({ children }: AppProps) {
  return (
    <QueryClientContextProvider>
      <AppContextProvider>
        <GlobalStyledContainer>{children}</GlobalStyledContainer>
      </AppContextProvider>
    </QueryClientContextProvider>
  )
}
